import momentFormat from "moment-parseformat";

function parse(d) {
    let date = new Date(d);
    if (isNaN(date.valueOf())) {
        return null;
    }
    date.setMinutes(date.getMinutes() + date.getTimezoneOffset());

    return date;
}

function format(d) {
    if (d.toLocaleDateString) {
        return d.toLocaleDateString();
    }

    return `${d.getMonth() + 1}/${t.getDate()}/${t.getFullYear()}`;
}

function formatString() {
    return momentFormat(format(new Date()));
}

export {parse, format, formatString};
